<template>
  <div>
    <v-app-bar
      height="64px"
      app
      class="blue-top-ouline elevation-1 m-header-app-bar"
      style="z-index: 10"
    >
      <v-app-bar-nav-icon class="ml-2" @click="toggleLeftMenu" />
      <m-apps-dropdown />
      <m-search-bar />
      <m-timezone />
      <v-spacer v-if="$vuetify.breakpoint.smAndUp || showSearch" />
      <template v-if="!serviceCloudExist && !settingsFrontend">
        <m-notifications />
      </template>
      <template v-if="settingsFrontend && ((serviceEnabled && marketingEnabled) || marketingEnabled)">
        <v-btn
        icon
        class="mx-3 d-none d-md-flex"
        @click="toggleNotificationDrawer"
        :class="notifications.unread > 99 ? 'long-notification-text' : ''"
      >
        <v-badge
          v-if="notifications.unread != 0"
          md-and-up
          overlap
          color="#F3425C"
          :class="notifications.unread > 99 ? 'px-1' : ''"
        >
          <template v-slot:badge>
            <span class="font-weight-bold ml-n1">{{ notifications.unread > 99 ? '99+' : notifications.unread }}</span>
          </template>
          <v-icon color="#616161" class="bell-icon">
            mdi-bell-alert
          </v-icon>
        </v-badge>
        <v-icon
          v-else
          color="#616161"
        >
          mdi-bell-alert
        </v-icon>
      </v-btn>
      </template>
      <template>
        <v-tooltip
          bottom
          color="rgba(0, 0, 0, 0.9)"
          v-if="serviceEnabled"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              class="d-md-flex"
              v-track="'header-navigate-to-settings'"
              @click="navigateToSettings()"
              icon
            >
              <v-icon :color="settingsFrontend ? 'mpBlue' : ''"> mdi-cog mdi-settings </v-icon>
            </v-btn>
          </template>
          <span>Admin Center</span>
        </v-tooltip>
      </template>
      <v-toolbar-items class="d-none d-md-flex">
        <m-accounts-dropdown />
        <m-user-dropdown />
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>
<script>
import config from "@core/config/app.config.js";
import MSearchBar from "@core/components/MSearchBar";
import MAppsDropdown from "@core/components/MAppsDropdown";
import MNotifications from "@core/components/MNotifications";
import MUserDropdown from "@core/components/MUserDropdown";
import MAccountsDropdown from "@core/components/MAccountsDropdown";
import MTimezone from "@core/components/MTimezone";
import { checkRolesAndRedirect } from '@core/config/utils'
import { getCookie } from "@core/config/utils";
import { mapGetters } from "vuex";
import { setAptrinsic } from "@core/config/gainsight/gainsight"
export default {
  name: "MHeader",
  components: {
    MSearchBar,
    MAppsDropdown,
    MNotifications,
    MUserDropdown,
    MAccountsDropdown,
    MTimezone
  },
  data() {
    return {
      serviceCloudExist: window.location.pathname.includes("service"),
      accountSearched: "",
      profileSubmenu: false,
      accountSubmenu: false,
      profileMenuToggle: false,
      accountToggle: false,
      mobileprofileMenuToggle: false,
      titleBarStyles: {
        width: this.$vuetify.breakpoint.name === "sm" ? "100%" : null,
        marginLeft: this.$vuetify.breakpoint.name === "sm" ? "0px" : null,
      },
      showSearch: false,
      showSearchIcon: true,
      showTitle: true,
      show: true,
      isSearchFocus: false,
      items: [
        [
          {
            title: "Account & Billing",
            icon: "mdi-account-cog",
            path: "/account-&-billing",
            uniqueId: "account-settings-nav-link",
            relative: true,
          },
          {
            title: "Profile",
            icon: "mdi-account-circle",
            uniqueId: "profile-settings-nav-link",
            newTab: true,
            path: `${config.MAROPOST_IDENTITY_BASE_URL}/#/profile`,
          },
          {
            title: "Settings",
            icon: "settings",
            relative: true,
            uniqueId: "email-settings-nav-link",
            path: "/settings",
          },
          {
            title: "Connections",
            icon: "mdi-power-plug",
            uniqueId: "connections-nav-link",
            relative: true,
            path: "/connections",
          },
        ],
        [
          {
            title: "Maropost Galaxy",
            image: "/img/icons/maropost-insignia.svg",
            uniqueId: "maropost-galaxy-nav-link",
            newTab: true,
            path: `${config.MAROPOST_IDENTITY_BASE_URL}/#/galaxy-login`,
          },
          {
            title: "Roadmap",
            icon: "mdi-emoticon-outline",
            uniqueId: "roadmap-nav-link",
            newTab: true,
            path: "/roadmap",
          },
          {
            title: "System Status",
            uniqueId: "system-status-nav-link",
            icon: "speed",
            newTab: true,
            path: "https://status.maropost.com",
          },
        ],
      ],
      processImg: "/img/icons/waiting-list-icon.svg",
      enableTimezone: false
    };
  },
  computed: {
    ...mapGetters({
      currentAccount: 'auth/account.current',
      notifications: 'ui/notifications'
    }),
    serviceEnabled: {
      get(){
        if(this.currentAccount)
          return this.currentAccount.enable_service
        return false
      },
      cache:false
    },
    marketingEnabled() {
      return this.currentAccount.enable_marketing
    },
    username() {
      let username = this.$store.getters["auth/username"] || "";
      if (typeof username == "object") {
        return `${username.firstName || ""} ${username.lastName || ""}`;
      } else {
        return username;
      }
    },
    menu_items() {
      const accountId = this.$store.getters["auth/account"].id;
      return this.items.map((item) => {
        item = item.map((subitem) => {
          if (subitem.relative && accountId) {
            subitem.path = subitem.path.replace(/\/accounts\/\d*/g, "");
            subitem.path = "/accounts/" + accountId + subitem.path;
          }
          return subitem;
        });

        return item;
      });
    },
    settingsFrontend() {
      const appBase = window.location.pathname.split('/')[1]
      return appBase === 'settings'
    },
  },
  mounted() { 
    setAptrinsic()
  },
  watch: {
    '$store.state.auth.roles': function () {
      let account = this.$store.getters['auth/account.current'];
      let userAccess = this.$store.getters['auth/userAccess'];
      if(account && userAccess){
        if(!checkRolesAndRedirect(account, userAccess)) {
          this.$router.push('/access-denied')
        }
      }
    },
  },
  methods: {
    toggleLeftMenu() {
      this.$store.commit("ui/leftmenu");
      //close folder menu on main menu open
      this.$store.commit("ui/folder.show", false);
    },
    navigateToSettings () {
      window.location.href = `/settings/${this.$store.getters['auth/account'].id}/dashboard`
    },
  },
};
</script>
<style>
.m-header-app-bar .v-toolbar__content {
  padding-left: 0;
  padding-right: 0px;
}
</style>
<style>
.blue-top-ouline {
  background: linear-gradient(180deg, #03b6fc 4px, #ffffff 4px);
}
.v-input__slot:not(.v-input--is-focused):before {
  border-width: 0 !important;
}
.caption {
  font-weight: 500 !important;
}
.topheader-height {
  top: 65px !important;
  right: 0px;
  max-width: 100% !important;
  left: 0px !important;
}
.small-badge .v-badge__badge {
  min-width: 15px;
  height: 15px;
  margin-top: 4px;
  margin-right: 8px;
}
.v-badge--overlap[mdAndUp] .v-badge__badge[mdAndUp] {
  top: -9px !important;
  left: 50%;
}
.highlight {
  z-index: 10 !important;
}
.profile-menu {
  overflow-y: auto;
}
.logoutbtn:hover {
  background-color: #f6f6f6 !important;
}
.v-badge--overlap .v-badge__badge,
.v-badge--overlap .v-badge__wrapper .v-badge__badge {
  position: absolute;
  right: -5px !important;
  left: 15px;
  font-size:11px
}
.m-notification-btn .v-badge--overlap .v-badge__wrapper .v-badge__badge {
  display: flex;
}
.m-notification-btn
  .v-badge--overlap
  .v-badge__wrapper
  .v-badge__badge
  .overline {
  align-self: center;
}
.long-notification-text .v-badge--overlap .v-badge__badge,
.long-notification-text .v-badge--overlap .v-badge__wrapper .v-badge__badge {
  right: -18px !important;
  left: 19px !important;
  padding-left: 5px !important;
}
.account-dropdown.v-select:link {
  color: #191919;
}
.account-dropdown {
  font-weight: 600 !important;
  letter-spacing: 0.55px;
  font-size: 13px !important;
}
.account-dropdown.v-select.v-text-field--enclosed:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__selections {
  padding-top: 0px;
}
.account-dropdown .v-text-field > .v-input__control > .v-input__slot:before,
.v-text-field > .v-input__control > .v-input__slot:after {
  content: none !important;
}
.account-dropdown
  .v-input__control
  > .v-input__slot
  > .v-select__slot
  > .v-select__selections
  > .v-select__selection {
  overflow: inherit !important;
}
.account-dropdown.v-select.v-text-field input {
  width: 0px;
}
.maro-logo {
  padding-top: 10px;
}
</style>
<style scoped>
.v-list-item__title {
  -ms-flex-item-align: center;
  align-self: center;
  font-size: 0.9rem;
}
.search-account-pd-br {
  padding: 4px;
  border-radius: 5px;
  margin-bottom: -20px;
}
.account-selected {
  width: max-content;
  line-height: 2.3;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-weight: 600;
}
.mr-arrow {
  margin-left: -12px !important;
  margin-top: 3px !important;
}
.responsive-logo {
  width: 100% !important;
  height: auto !important;
}
.bell-icon {
  position:relative
}
</style>
